const getEnvironment = () => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('devmodifyhealth') || hostname.includes('localhost')) {
    return 'development';
  } 
  else if (hostname.includes('test-modifyhealth')) {
    return 'test';
  } 
  else {
    return 'production';
  }
};

const SHOP_DOMAINS = {
  development: 'devmodifyhealth.myshopify.com',
  test: 'test-modifyhealth.myshopify.com',
  production: 'modifyhealth.myshopify.com'
};

const RECHARGE_TOKENS = {
  development: process.env.REACT_APP_RECHARGE_STOREFRONT_API_KEY_DEV,
  test: process.env.REACT_APP_RECHARGE_STOREFRONT_API_KEY_TEST,
  production: process.env.REACT_APP_RECHARGE_STOREFRONT_API_KEY_PROD
};

const BUNDLE_IDS = {
  development: {
    'Mediterranean Plan': '14904502026601',
    'Low-FODMAP Plan': '14904502026602',
    'Diabetes Plan': '14904502026603',
    'Gluten-Free Plan': '14904502026604',
    'Heart-Friendly Plan': '14904502026605',
    'Carb-Conscious Plan': '14904502026606',
    'B2B Plan': '14904502026607',
    'Care Plan': '14904502026608',
    'GLP-1 Plan': '14904502026604', 
  },
  test: {
    'Mediterranean Plan': '14903531962732',
    'Low-FODMAP Plan': '14915479634284',
    'Diabetes Plan': '14915485139308',
    'Gluten-Free Plan': '14915486351724',
    'Heart-Friendly Plan': '14919811432812',
    'Carb-Conscious Plan': '14919826604396',
    'B2B Plan': '14904502026607',
    'Care Plan': '14904502026608',
    'GLP-1 Plan': '14910887166316', 
  },
  production: {
    'Mediterranean Plan': '9052931260534',
    'Low-FODMAP Plan': '9052639199350',
    'Diabetes Plan': '8110087798902',
    'Gluten-Free Plan': '8110121386102',
    'Heart-Friendly Plan': '8110105526390',
    'Carb-Conscious Plan': '8110079639670',
    'B2B Plan': '14898064785779',
    'Care Plan': '14898064785780',
    'GLP-1 Plan': '8110115586166', 
  }
};

export const getBundleId = (dietType) => {
  const env = getEnvironment();
  const bundleIds = BUNDLE_IDS[env] || BUNDLE_IDS.production;
  
  return bundleIds[dietType];
};

export const getShopDomain = () => {
  const env = getEnvironment();
  return SHOP_DOMAINS[env] || SHOP_DOMAINS.production;
};

export const getRechargeToken = () => {
  const env = getEnvironment();
  return RECHARGE_TOKENS[env];
};

export const bundleConfig = {
  getBundleId,
  getShopDomain,
  getRechargeToken,
  getEnvironment,
  BUNDLE_IDS,
  SHOP_DOMAINS
};